export default "__VITE_ASSET__zr4Zbf4p__"